
define([
    'base',
    'module',
    'core',
    'require',
    'angular',
    'ui',
    './router',
    './service/PlatformService',
    './routerExtras',
    './service/Navigation',
    './service/NavigationalService',
    './directives/directives',
    './service/EventManager'
], function(base, module, core, require, angular, ui) {

    'use strict';
    module.name = "fm.base"
    var deps = [
        core.name,
        ui.name,
        "ui.router",
        "ct.ui.router.extras",
    ];



    function run($rootScope, $location, $previousState, $stickyState, $state, $timeout, $window, $q, PlatformService, NavigationService, $document) {


        if($state.get((PlatformService.getWidgetName()+".default"))){

            var _isNotMobileBaseOnSize = PlatformService._isNotMobileBaseOnSize;





            var browserBackPressed = false;
            $window.addEventListener('webviewBack', function(param) {
                NavigationService.back();

            });



            $rootScope.$on('$stateChangeSuccess', function(ev, to, toParams, from, fromParams) {
                $document.context.body.scrollTop = $document.context.documentElement.scrollTop = 0;
                console.debug("State change is observed from ->",from,"to ->",to)


                if(to.mode){
                    if(to.mode.desktop === 'popup'){
                        gadgets.pubsub.publish('POPUP_HAS_HISTORY');
                    }
                }

                if(to.name.contains(".popup.")){
                    console.debug("Popup state entered")
                    console.debug("2) On Enter of  popup state -- >",to)
                    if(!$previousState.get("MAIN-COVER")){
                        console.debug("NO Previous Memorised state before popup, hence memorising",$previousState.get())

                        $state.$custom_$memo=$previousState.get().state.name;
                        $previousState.memo("MAIN-COVER");
                    }else{
                        console.debug("Already inn popup state,not  hence memorising")
                    }
                }

                var momorisedState=$previousState.get("MAIN-COVER");
                if(!momorisedState){
                    momorisedState={};
                    momorisedState.state={};
                    momorisedState.state.name="none";
                }
                if((!/.popup./.test(to.name))&&(!/.popup./.test(momorisedState.state.name))){
                    gadgets.pubsub.publish('titleChange', {
                        title: to.title
                    })
                }

                if (to.name == momorisedState.state.name) {
                    console.debug("Resetting state --> ", from.name)



                    var parentResetName = from.name.substring(0, (from.name.indexOf(".popup.") + 6));
                    $stickyState.reset(parentResetName);
                    $state.$custom_$memo = ""
                    $previousState.forget("MAIN-COVER");
                }

                if ($state.dontStoreInHistory == false) {
                    gadgets.pubsub.publish('HAS_HISTORY', {isPopup: /.popup./.test(to.name)})
                    if (!$rootScope.previousState) {
                        $rootScope.previousState = [];
                    }
                    console.debug("HAS History is published and previoius state is added",from)
                    $rootScope.previousState.push(from);
                    $rootScope.previousStateName = from.name;
                } else {
                    console.debug("State is not added in history as flag is true",from)
                    $state.dontStoreInHistory = false;
                }


                if((!/.popup./.test(to.name))&&(!/.popup./.test(momorisedState.state.name))){
                if (to.events) {
                    var eventKeys = Object.keys(to.events);

                    for (var i = 0; i < eventKeys.length; i++) {
                        gadgets.pubsub.publish(eventKeys[i], to.events[eventKeys[i]])
                    }
                }
                var eventType = (typeof cxp !== 'undefined') ? "nativeEvents" : "browserEvents"
                if (to[eventType]) {
                    var eventKeys = Object.keys(to[eventType]);

                    for (var i = 0; i < eventKeys.length; i++) {
                        gadgets.pubsub.publish(eventKeys[i], to[eventType][eventKeys[i]])
                    }
                }
                }

                if(typeof to.mode !='undefined'){
                    if(!$state.current.notMainWidget && !$state.current.name.includes("default") && to.mode.desktop!="popup"){

                        gadgets.pubsub.publish("bannerIdentifier",{"name":"clearBanners"});
                    }
                }
            });


            var getNavData = function() {
                var extrasPlugin = typeof cxp !== 'undefined' && cxp.mobile.plugins['ExtrasPlugin'];
                if (extrasPlugin) {
                    var deferred = $q.defer();
                    extrasPlugin.getStateAndExtras(function(extras) {
                        deferred.resolve(extras);
                    });
                    return deferred.promise
                } else {
                    return {}
                }
            }


            if (typeof cxp == 'undefined') {
                $state.forwardCall = true;
                var location = $location.path().trim();
                var states = $state.get();
                var length = states.length;
                var widgetName = PlatformService.getWidgetName()
                var startState = widgetName+".default";

                if (location != "" && location != "/"){
                    for (var i = 0; i < length; i++) {
                        var tempState = states[i];
                        if (tempState.referenceURL == location) {
                            startState = tempState.name;
                            break;
                        }
                    }
                }
                var widgetName = PlatformService.getWidgetName()
                if ($state.get(startState) != undefined) {
                    var extr = sessionStorage.getItem("transactionData");
                    if(widgetName != "widget-hdfc-favorite-nb"){
                        sessionStorage.removeItem("transactionData");
                    }
                    if (extr && $state.get(startState))
                        $state.get(startState).$extras = JSON.parse(extr);
                    if ($state.get(startState))
                        $timeout(function () {
                            $state.go(startState,{},{location:false});
                        }, 100)
                }
            } else {
                getNavData().then(function(extras) {
                    if (!!extras.data && !!extras.data.wrapper) {
                        if( $state.get(widgetName+"."+extras.state)){
                         $state.get(widgetName+"."+extras.state).$extras = extras.data.wrapper;
                         }
                    }
                    if( $state.get(widgetName+"."+extras.state)){
                     $state.go(widgetName+"."+extras.state,{},{location:false});
                     }
                });
            }
        }
    }

    module.exports = base.createModule(module.name, deps)
        .provider(require('./service/PlatformService'))
        .provider('Navigation',require('./service/Navigation').Navigation)
        .service(require('./service/NavigationalService'))
        .service(require('./service/EventManager'))
        .directive(require('./directives/directives'))
        .config(function() {
        })
        .run(run)

});


// WEBPACK FOOTER //
// ./src/feature-hdfc-navigation/scripts/index.js